import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ExternalLink, ChevronDown, Shield, Rocket, Users, Award, TrendingUp, Lock } from "lucide-react";
import { Link } from "react-router-dom";

/* ===== Images ===== */
import chematico from "../../images/chematico.jpeg";
import evigway from "../../images/evigway.jpeg";
import fulectronix from "../../images/FULECTRONIX_TECHNOLOGY.jpg";
import greeninv from "../../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../../images/JYOMA_SOLUTIONS.jpg";
import renao from "../../images/renao.jpg";
import rosch from "../../images/rosch-crete.jpg";
import ironfist from "../../images/ironfist.png";
import optimized from "../../images/Optimized Electrotech.png"
import agniverse from "../../images/agniverse.png";
import Samarthya from "../../images/Samarthya.png";
import Thoughtrons from "../../images/Thoughtrons1.png";
import Neelman from "../../images/Neelman Infra Pvt Ltd.png"
import farata from "../../images/Farata.png"
import Dronosaur from "../../images/Dronosaur Private Limited.png"
import Aerial from "../../images/Aerial borne Pvt Ltd.png"
import Labrys from "../../images/Labrys.png";
import Huskage from "../../images/Huskage.png";
import texoedge from "../../images/Texoedge.jpg";
import ML from "../../images/ML.png";
//import ostravion from "../../images/ostravion.png";
import Stravex from "../../images/Stravex Technologies Pvt Ltd.png"
import C4Composite from "../../images/C4 Composite innnovtions Pvt Ltd.png"
import Aaizel from "../../images/Aaizel International Technologies Private Limited.png"
import Astra from "../../images/Astra Drones and Robotics Solutions Pvt Ltd.png"
import SiGeAu from "../../images/SiGeAu Ohmtecture (OPC) Pvt Ltd.png"
import DiscovBEE from "../../images/DiscovBEE Research & Innovation (OPC) Pvt Ltd.png"
import Artemis from "../../images/ARTEMISTRONIKS INDIA PRIVATE LIMITED.jpeg"
import pacedefence from "../../images/Pace defence Systems Pvt Ltd.png"
//import utsedha from "../../images/utsedha.jpeg";
import Techlanz from "../../images/Techlanz Private limited.png"
import Gandiv from "../../images/GANDIV AI AND DEFENCE SYSTEM PRIVATE LIMITED.png"
import Cyberjoar from "../../images/Cyber Joar Pvt Ltd.png"
//import srisamba from "../../images/srisamba.jpg"
import MARCG from "../../images/MARCG Drones & Innovations Pvt Ltd.jpeg"
import AstraDrones from "../../images/Astra Drones and Robotics Solutions Pvt Ltd.png"
import robustrix from "../../images/Robustrix IT Solutions Pvt Ltd.png"
import Nuture from "../../images/Nuture Aerospace Pvt ltd.png"

/* Hero Background */
import heroBg from "../../images/Defence_header_BG.png";

/* Defence Startups */
const defenceStartups = [
  { img: jyoma, name: "Jyoma Solutions", link: "https://jyomasolutions.com/", description: "Advanced surveillance systems for national security" },
  { img: evigway, name: "Evigway Technologies", link: "http://www.evigway.com/", description: "Electric vehicle solutions for defense mobility" },
  { img: ironfist, name: "Ironfist Arms", link: "https://www.ironfistarms.org/", description: "Advanced weaponry and ammunition solutions" },
  { img: chematico, name: "Chematico Technologies", link: "http://www.chematico.com/", description: "Specialized materials for defense applications" },
  { img: rosch, name: "Roschcrete Technologies", link: "http://roschcrete.com/", description: "High-performance concrete for military infrastructure" },
  { img: fulectronix, name: "Fulectronix Technologies", link: "http://www.fulectronix.in/", description: "Robotic solutions for defense operations" },
  { img: renao, name: "Renao Robotics", link: "/", description: "Tactical robotic systems and solutions" },
  { img: optimized, name: "Optimized Electrotech", link: "https://optimizedelectrotech.com/", description: "AI-powered multi-spectral imaging system for automated threat detection" },
  { img: agniverse, name: "Agniverse Technologies", link: "https://www.agniverse.co/", description: "Lightweight Kevlar composites for armor, ballistic, and EMI-shielding applications" },
  { img: Samarthya, name: "Samarthya Defence Research & Technology", link: "https://samarthyadefence.com/", description: "Smart Grenade with electronic fuses and multiple detonation modes" },
  { img: Nuture, name: "Nurture Aerospace", link: "/", description: "AI-powered robotics and drones solutions" },
  { img: Thoughtrons, name: "Thoughtrons", link: "https://thoughtrons.in/", description: "Agentic AI consulting platform for defence and dual-use tech startups" },
  { img: Neelman, name: "Neelman Infra", link: "/", description: "CBRN-protected underground bunkers for extreme emergency survival" },
  { img: farata, name: "Farata Technologies", link: "https://farata.tech", description: "UAVs, drone components, and counter-drone systems for military and civil use" },
  { img: Dronosaur, name: "Dronosaur", link: "https://dronosaur.in/", description: "AI-powered autonomous drone offering hands-free videography via gesture and voice control" },
  { img: Aerial, name: "Aerial Borne", link: "https://aerialborne.com/", description: "Aerial intelligence, drone hardware, and services marketplace for enterprises, government, and defense" },
  { img: Labrys, name: "Labrys Solutions", link: "https://labryssolutions.com/", description: "Video compression and AI-based analytics for VMS platforms, including face recognition and monitoring" },
  { img: Huskage, name: "Huskage Innovations", link: "https://www.huskage.com", description: "Green hydrogen production from biomass gasification, powering high-payload drones" },
  { img: texoedge, name: "Texoedge Innovation", link: "https://texoedge.in/", description: "Nanomaterial-based textiles with adjustable warming and cooling for defence and sports use" },
  { img: ML, name: "ML WorkX", link: "https://www.mlworkx.com/", description: "Cloud-connected electronics manufacturing platform for rapid product delivery at scale" },
  //{ img: ostravion, name: "Ostravion Technology", link: "https://www.linkedin.com/company/ostraviontech2025/about/", description: "Smart power distribution boards with predictive maintenance for drone manufacturers" },
  { img: Stravex, name: "Stravex Technologies", link: "https://www.stravextechnologies.com", description: "Indigenous AI-powered counter-drone and tactical UAV systems for Indian armed forces" },
  { img: C4Composite, name: "C4 Composite Innovations", link: "https://www.c4composites.in", description: "Carbon fiber composite R&D and manufacturing for aerospace, defence, and industrial use" },
  { img: Aaizel, name: "Aaizel International Technologies", link: "http://www.aaizeltech.com", description: "Sovereign AI battlefield decision intelligence platform fusing multi-domain sensor data" },
  { img: Astra, name: "Astra Drones and Robotics Solutions", link: "http://www.astradrobotics.in", description: "Made-in-India drone solutions and robotics lab infrastructure for defense and disaster management" },
  { img: robustrix, name: "Robustrix IT Solutions", link: "http://therobustrix.com", description: "AI/ML-enabled fanless industrial PCs for edge computing and real-time analytics" },
  { img: SiGeAu, name: "SiGeAu Ohmtecture", link: "http://sigeau.in", description: "Indigenous development of mission-critical electronic components for defence PSUs" },
  { img: DiscovBEE, name: "DiscovBEE Research & Innovation", link: "/", description: "Military UAV technology and complete technology blueprints to reduce foreign dependency" },
  { img: Artemis, name: "Artemistroniks India", link: "http://www.artemistroniks.com", description: "AI-driven predictive maintenance monitoring for battery and HVAC systems in defence installations" },
  { img: pacedefence, name: "Pace Defence Systems", link: "http://www.pacedefence.com", description: "Trading and supply of critical defence electronics for India's defence and paramilitary forces" },
  //{ img: utsedha, name: "Utsedha Unmanned", link: "https://www.utsedha.com", description: "AI-powered robotic painting solution for automated, precise industrial painting" },
  //{ img: veritrufide, name: "Veritrufide Accura", link: "", description: "Digital identity verification infrastructure for traceability in offline interactions" },
  { img: Techlanz, name: "Techlanz", link: "http://www.techlanz.com", description: "Made-in-India battery systems with Smart BMS and digital twin tech for drone operators" },
  // { img: friskfly, name: "Friskfly Tech Devices", link: "https://ftd-innovations.com/", description: "Drone electronics — flight controllers, ESCs, and BMS — as a non-Chinese alternative for defense and government" },
  //{ img: aeronyan, name: "AeroNyan", link: "http://www.aeronyan.com", description: "Drone-based aerial data collection, mapping, and analytics for agriculture and infrastructure" },
  { img: Gandiv, name: "Gandiv AI and Defence System", link: "https://www.linkedin.com/company/gandiv-ai-and-defence-system-private-limited/", description: "AI-powered integrated defense systems spanning drones, avionics, and radar" },
  // { img: avkashyaan, name: "Avkashyaan", link: "https://www.starlabsurat.com/", description: "Hands-on space and rocketry education through experiential training programs" },
  { img: MARCG, name: "MARCG Drones & Innovations", link: "/", description: "Customised drone and aerospace systems with end-to-end engineering consultancy" },
  // { img: indiamoonmars, name: "IndiaMoonMars", link: "", description: "AI-powered analog astronaut habitats and mission simulation systems for space training" },
  // { img: srisanba, name: "Sri Saamba Parmeshwara Industries", link: "", description: "Autonomous electric logistics platform with EV cargo vehicles for defense and industrial use" },
  // { img: quietlabs, name: "Quiet Labs", link: "", description: "Autonomous quadruped robot for landmine detection and ground marking" },
  //  { img: spatiallycollab, name: "Spatially Collaborative Engineering", link: "https://www.space-labs.in", description: "AI-based automated inspection systems for railway wheel profiling and industrial QC" },
  { img: Cyberjoar, name: "CyberJoar AI", link: "https://www.cyberjoar.com/", description: "Secure, scalable AI platforms for privacy-sensitive and offline enterprise environments" },

];


export default function DefenceStartup() {
  const { scrollYProgress } = useScroll();
  const yContent = useTransform(scrollYProgress, [0, 0.2], [0, -40]);
  const opacity = useTransform(scrollYProgress, [0, 0.15], [1, 0]);

  const handleScrollToContent = () => {
    window.scrollTo({ top: window.innerHeight * 0.85, behavior: "smooth" });
  };

  return (
    <div className="bg-white min-h-screen font-sans text-slate-900 overflow-x-hidden selection:bg-blue-100 selection:text-blue-900">

      {/* ================= DEFENCE HERO ================= */}
      <section className="relative h-[60vh] min-h-[450px] w-full overflow-hidden flex items-center justify-center bg-slate-950">

        {/* Modern Minimal Background */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <motion.img
            src={heroBg}
            alt="Defence Innovation"
            className="w-full h-full object-cover object-center opacity-70"
            initial={{ scale: 1.05 }}
            animate={{ scale: 1 }}
            transition={{ duration: 3, ease: "easeOut" }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-slate-950/60 to-slate-950" />

          {/* Subtle Grid Pattern */}
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.02]" />
        </div>

        {/* Content Overlay */}
        <motion.div
          style={{ y: yContent, opacity }}
          className="relative z-10 w-full px-6 max-w-5xl mx-auto text-center mt-16"
        >

          {/* Main Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold text-white mb-8 tracking-tight leading-tight"
          >
            Advancing <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
              Defence Innovation
            </span>
          </motion.h1>

          {/* Subtext */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-slate-400 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed font-light"
          >
            Empowering visionary startups to build mission-critical technologies, from advanced robotics and multi-spectral imaging to tactical AI systems.
          </motion.p>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 hidden md:flex flex-col items-center gap-2"
        >
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            className="flex flex-col items-center gap-3 cursor-pointer group"
            onClick={handleScrollToContent}
          >
            <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400 group-hover:text-blue-400 transition-colors duration-300">
              Explore
            </span>
            <div className="relative flex items-center justify-center p-3 rounded-full bg-white/5 backdrop-blur-xl border border-white/10 group-hover:border-blue-400/50 group-hover:bg-white/10 transition-all duration-500 shadow-2xl">
              <ChevronDown size={22} className="text-slate-300 group-hover:text-blue-400 transition-colors duration-300" strokeWidth={2.5} />
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* ================= SECTION HEADER ================= */}
      <section className="max-w-7xl mx-auto px-6 pt-24 pb-16 relative">
        {/* Background Accent */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-12 bg-gradient-to-b from-slate-200 to-transparent" />

        <div className="text-center max-w-3xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >

            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">
              Defence-Based Startups
            </h2>

            <p className="text-slate-600 text-lg md:text-xl leading-relaxed font-light">
              Explore the specialized portfolio of companies securing our future through breakthrough technologies and strategic innovations.
            </p>

            {/* Visual Divider */}
            <div className="mt-10 flex items-center justify-center gap-4 opacity-70">
              <div className="h-[1px] w-16 bg-gradient-to-r from-transparent to-slate-300" />
              <div className="w-1.5 h-1.5 rounded-full bg-slate-400" />
              <div className="h-[1px] w-16 bg-gradient-to-l from-transparent to-slate-300" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= MODERN STARTUP GRID ================= */}
      <section className="max-w-7xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {defenceStartups.map((startup, index) => (
            <motion.div
              key={startup.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: index * 0.05, duration: 0.6 }}
              className="group flex flex-col h-full"
            >
              {/* Image Container */}
              <a
                href={startup.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="block relative h-56 w-full rounded-2xl bg-slate-50 border border-slate-100 overflow-hidden mb-6 flex-shrink-0"
              >
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500 z-10" />
                <img
                  src={startup.img}
                  alt={startup.name}
                  className="w-full h-full object-contain p-8 mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                />
              </a>

              {/* Content */}
              <div className="flex flex-col flex-grow">
                <h3 className="text-xl font-semibold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                  {startup.name}
                </h3>

                <p className="text-slate-600 leading-relaxed text-sm mb-6 flex-grow">
                  {startup.description}
                </p>

                {startup.link && (
                  <a
                    href={startup.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-300 mt-auto"
                  >
                    Visit Website
                    <svg className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= CALL TO ACTION ================= */}
      <div className="py-24 bg-white text-center px-6 relative overflow-hidden border-t border-slate-100">
        <div className="max-w-4xl mx-auto relative z-10">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl font-bold text-slate-900 mb-6 tracking-tight">
              Scale Your Defence Startup
            </h2>

            <p className="text-slate-600 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
              Gain access to IIT Ropar’s Defence Ecosystem, specialized testing labs, defence procurement pathways, and strategic support for dual-use technologies.
            </p>

            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://forms.gle/Fz2pn47EqTscZK4T8"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-10 py-5 rounded-full font-bold text-lg shadow-xl shadow-blue-600/30 transition-all"
            >
              Apply for Incubation
            </motion.a>
          </motion.div>
        </div>
      </div>

    </div>
  );
}